module.exports = __webpack_public_path__ + "static/media/5.Chain Pana.cfe99692.jpg";